export const DISCOUNT_BADGES_ENABLED = false;
